import React from "react";
import { motion } from "framer-motion";
import { Stethoscope, Scale, PenTool, Brain, School } from "lucide-react";

const pathways = [
  { icon: Stethoscope, label: "Medical Education Pathways", color: "#FFF1F2", iconColor: "#EF4444" },
  { icon: Scale, label: "Law Pathways", color: "#EEF0FC", iconColor: "#2B2F9E" },
  { icon: PenTool, label: "Architecture and Design Portfolios", color: "#FFF7E6", iconColor: "#F5A000" },
  { icon: Brain, label: "Public Health, Psychology, Data and AI Pathways", color: "#F0FDF4", iconColor: "#10B981" },
];

export default function SpecialisedPathways() {
  return (
    <section
      id="specialised"
      data-testid="specialised-pathways-section"
      style={{ padding: "80px 0", backgroundColor: "#fff" }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ marginBottom: "40px" }}
        >
          <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>
            Niche Expertise
          </span>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(24px, 2.5vw, 34px)", fontWeight: "700", color: "#0F172A", margin: "12px 0 0", lineHeight: "1.25" }}>
            Specialised pathways
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={{ show: { transition: { staggerChildren: 0.1 } } }}
          style={{ gap: "16px", marginBottom: "20px" }}
          className="mw-grid-4"
        >
          {pathways.map((p) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.label}
                variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }}
                data-testid={`pathway-${p.label.slice(0, 10).toLowerCase().replace(/\s+/g, "-")}`}
                style={{ backgroundColor: p.color, borderRadius: "12px", padding: "28px 24px", display: "flex", flexDirection: "column", gap: "12px" }}
                whileHover={{ y: -4 }}
              >
                <div style={{ width: "44px", height: "44px", borderRadius: "10px", backgroundColor: "rgba(255,255,255,0.7)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon size={22} style={{ color: p.iconColor }} />
                </div>
                <p style={{ fontSize: "15px", fontWeight: "600", color: "#0F172A", fontFamily: "'DM Sans', sans-serif", margin: 0, lineHeight: "1.4" }}>
                  {p.label}
                </p>
              </motion.div>
            );
          })}
        </motion.div>

        {/* Elite Boarding School Advisory */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          data-testid="pathway-boarding-school"
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            backgroundColor: "#EFF6FF",
            borderRadius: "12px",
            padding: "28px 32px",
            border: "1px solid #BFDBFE",
            marginBottom: "24px",
          }}
        >
          <div style={{ width: "52px", height: "52px", borderRadius: "12px", backgroundColor: "rgba(255,255,255,0.8)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <School size={24} style={{ color: "#3B82F6" }} />
          </div>
          <div>
              <h4 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", fontWeight: "700", color: "#0F172A", margin: "0 0 8px" }}>
              Elite Boarding School Advisory
            </h4>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "14px", color: "#475569", margin: 0, lineHeight: "1.6", maxWidth: "700px" }}>
              Boarding school selection for families considering elite pre-university schools in the UK, Switzerland, and USA. School research, shortlisting, personal statement guidance, and application support — delivered through our specialist partner network.
            </p>
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          style={{ fontSize: "14px", color: "#64748B", fontFamily: "'DM Sans', sans-serif", fontStyle: "italic", padding: "16px 20px", backgroundColor: "#F8FAFC", borderRadius: "8px", borderLeft: "3px solid #2B2F9E", margin: 0 }}
        >
          Requirements vary by country and university. We guide pathway strategy and admissions execution. For licensing or regulated steps, we guide the process and connect specialist partners where needed.
        </motion.p>
      </div>
    </section>
  );
}
